export const BUSINESS_TRIAL_SUCCESS_DEMO_CENTER = {
  "en": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "fr": "Vous voulez voir Dashlane en action ? <a href=\"/demo\">Visitez notre centre de démonstration</a>",
  "de": "Sie möchten Dashlane in Aktion sehen? <a href=\"/demo\">Besuchen Sie unser Demo-Center</a>",
  "es": "¿Quiere ver Dashlane en acción? <a href=\"/demo\">Visite nuestro Centro de demostraciones</a>",
  "pt-br": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "it": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "ja": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "ko": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "nl": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "pt-pt": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "sv": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>",
  "zh": "Want to see Dashlane in action? <a href=\"/demo\">Visit our Demo Center</a>"
}